import { SubscriptionType } from 'src/user/fragments'
import { SubscriptionStatus } from 'src/graphql'
import { ELITE_ELIGIBLE_PLANS } from 'src/marketing/plans/constants'

const hasNotLimitedPlan = (subscriptions: SubscriptionType[]): boolean => {
  return subscriptions.some(
    s =>
      (s.status === SubscriptionStatus.ACTIVE ||
        s.status === SubscriptionStatus.TRIALING) &&
      ELITE_ELIGIBLE_PLANS.includes(s.sku),
  )
}

export default hasNotLimitedPlan
